import { Box, CircularProgress } from '@mui/joy'

type Props = {}

const Loader = (props: Props) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                alignItems: 'center',
            }}
        >
            <CircularProgress color="primary" size="lg" />
        </Box>
    )
}
export default Loader
